<template>
  <div class="partner-resumes-base-resumes__table-row  partner-resumes-base-resumes-row">
    <div class="partner-resumes-base-resumes__table-cell  _candidate">
      <div class="partner-resumes-base-resumes__table-cell-title  d-none  d-md-block">
        {{ $tResumesBaseResumes('Candidate') }}
      </div>
      <div class="partner-resumes-base-resumes-id__item-date  dropdown  _top" v-if="resume.id">
        <div class="dropdown__content">
          <div
               :style="{marginBottom: resume.id ? '0.4rem' : null}">
            #{{ resume.id }}
          </div>
        </div>
      </div>
      <APResumesBaseResumePageRowCandidate :resume="resume"/>
    </div>

    <div class="partner-resumes-base-resumes__table-cell  _status">
      <div class="partner-resumes-base-resumes__table-cell-title  d-none  d-md-block">
        {{ $tResumesBaseResumes('Status') }}
      </div>
      <APResumesBaseResumePageRowStatus :resume="resume"/>
    </div>

    <div class="partner-resumes-base-resumes__table-cell  _referral">
      <div class="partner-resumes-base-resumes__table-cell-title  d-none  d-md-block">
        {{ $tResumesBaseResumes('Invited by') }}
      </div>
      <div class="partner-resumes-base-resumes-id__item-date  dropdown  _top" v-if="resume.partner.id">
        <div class="dropdown__content">
          <div :style="{marginBottom: resume.partner.id ? '0.4rem' : null}">
            #{{ resume.partner.id }}
          </div>
        </div>
      </div>
      <APResumesBaseResumePageRowReferral :resume="resume"/>
    </div>


    <div class="partner-resumes-base-resumes__table-cell  _actions">
      <BaseMenu :card-style="{ right: '0', top: '0' }" close-on-content-click>
        <template v-slot:activator="{ on }">
          <button
            class="base-btn"
            v-on="on"
          >
            <BaseSvg name="ico-dots" width="0.3rem" height="1.7rem" />
          </button>
        </template>

        <div class="d-flex flex-column">
          <router-link-modified
            v-if="resume.resume_id"
            :to="{name: resumePageRouteName, params: {resumeId: resume.resume_id}}"
            class="partner-resumes-base-resumes-row__action-btn base-btn base-btn--x-small base-btn--outline-dark base-btn--small"
          >
            {{ $tResumesBaseResumes('Resume') }}
          </router-link-modified>
          <button
            v-if="showResend && !resume.active_questionnaire"
            :disabled="resume.disable_resend_btn || loading.resend"
            class="partner-resumes-base-resumes-row__action-btn base-btn base-btn--x-small base-btn--outline-dark base-btn--small"
            @click="resendInvitation"
          >
            {{ $tResumesBaseResumes('resend link') }}
          </button>
          <button
            class="partner-resumes-base-resumes-row__action-btn base-btn base-btn--x-small base-btn--outline-dark base-btn--small"
            @click="respondByCandidate"
          >
            {{ $tVacancy(resume.sent_resume_id ? 'questionnaire_partner_answer' : 'Respond') }}
          </button>

          <router-link-modified
            v-if="resume.need_questionnaire"
            class="partner-resumes-base-resumes-row__action-btn base-btn base-btn--x-small base-btn--outline-dark base-btn--small"
            :to="agentQuestionnaireRoute"
          >
            {{ $tResumesBaseResumes('agent_questionnaire') }}
          </router-link-modified>
        </div>
      </BaseMenu>
    </div>
  </div>
</template>

<script>
  import APResumesBaseResumePageRowCandidate
    from '@/components/partnerResumeBaseResumes/APResumesBaseResumePageRowCandidate'
  import APResumesBaseResumePageRowReferral
    from '@/components/partnerResumeBaseResumes/APResumesBaseResumePageRowReferral'
  import APResumesBaseResumePageRowStatus
    from '@/components/partnerResumeBaseResumes/APResumesBaseResumePageRowStatus'
  import {http} from '@/axios'
  import {mapGetters} from 'vuex'

  export default {
    name: 'APResumesBaseResumePageRow',
    components: {
      APResumesBaseResumePageRowCandidate,
      APResumesBaseResumePageRowReferral,
      APResumesBaseResumePageRowStatus,
    },
    props: {
      resume: Object
    },
    data() {
      return {
        loading: {
          resend: false,
        },

        storage: JSON.parse(localStorage.getItem('resentLinks')) || [],
        showResend: true,
      }
    },
    mounted() {
      this.checkResend()
    },
    computed: {
      ...mapGetters('user', [
        'isPartner',
        'isModerator',
      ]),
      resumePageRouteName() {
        if (this.isPartner) {
          return 'account-partner-resumes-base-resume'
        }
        if (this.isModerator) {
          return 'account-moderator-candidates-resume'
        }

        //isAgent
        return 'account-agent-resumes-base-resume'
      },
      agentQuestionnaireRoute() {
        const query = {};
        if (this.resume.phone) query.phone = this.resume.phone;
        if (this.resume.firstname) query.firstName = this.resume.firstname;
        if (this.resume.lastname) query.lastName = this.resume.lastname;

        return { name: 'register-candidate', query };
      },
    },
    methods: {
      checkResend() {
        this.showResend = !!this.resume.id;
      },
      resendInvitation() {
        if (this.loading.resend) return;

        const {id} = this.resume

        this.loading.resend = true;
        return http.post(`/api/cabinet/agent/resend-invite/${id}`)
          .then(() => {
            this.$emit('resend', id)
            this.resume.disable_resend_btn = true;

            this.$vModal.open('successfully-sent', {
              title: this.$tResumesBaseResumes('successfully-resent'),
            })
          })
          .catch(e => {
            this.$vModal.open('warning', {
              title: this.$tResumesBaseResumes('resend-error-title'),
              message: e.response.data.message
            })
          })
          .finally(() => this.loading.resend = false);
      },
      respondByCandidate() {
        if (this.resume.sent_resume_id) {
          this.$router.push({
            name: 'response-additional-questions',
            params: { sentResumeId: this.resume.sent_resume_id },
          });
          return;
        }
        sessionStorage.setItem('selected_response_candidate_id', this.resume.id);
        this.$router.push({ name: 'vacancies' });
      },
    }
  }
</script>

<style lang="less">

</style>
